import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAuthoringReview_batchesComponent } from './page.authoring.review_batches/page.authoring.review_batches.component';
import { PageAuthoringReleasesComponent } from './page.authoring.releases/page.authoring.releases.component';
import { PageAuthoringDashboardComponent } from './page.authoring.dashboard/page.authoring.dashboard.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAuthoringQualityComponent } from './page.authoring.quality/page.authoring.quality.component';
import { PageWorkspaceComponent } from './page.workspace/page.workspace.component';
import { PageAuthoringDatasetsComponent } from './page.authoring.datasets/page.authoring.datasets.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageAuthoringAdjudicationsComponent } from './page.authoring.adjudications/page.authoring.adjudications.component';
import { PageAuthoringRunsComponent } from './page.authoring.runs/page.authoring.runs.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAuthoringCandidatesComponent } from './page.authoring.candidates/page.authoring.candidates.component';
import { PageStatusForbiddenComponent } from './page.status.forbidden/page.status.forbidden.component';
import { LayoutReviewComponent } from './layout.review/layout.review.component';
import { PageReviewTasksComponent } from './page.review.tasks/page.review.tasks.component';
import { PageStatusNot_foundComponent } from './page.status.not_found/page.status.not_found.component';
import { LayoutAuthoringComponent } from './layout.authoring/layout.authoring.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminAccountsComponent } from './page.admin.accounts/page.admin.accounts.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageStatusPendingComponent } from './page.status.pending/page.status.pending.component';
import { PageAuthoringSourcesComponent } from './page.authoring.sources/page.authoring.sources.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PageAuthoringText_unitsComponent } from './page.authoring.text_units/page.authoring.text_units.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonTreeComponent,
        PageAuthoringReview_batchesComponent,
        PageAuthoringReleasesComponent,
        PageAuthoringDashboardComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonFormDropdownComponent,
        PageAuthoringQualityComponent,
        PageWorkspaceComponent,
        PageAuthoringDatasetsComponent,
        PortalSeasonModalComponent,
        PageAuthoringAdjudicationsComponent,
        PageAuthoringRunsComponent,
        LayoutAuthComponent,
        PortalSeasonPaginationComponent,
        PageAuthoringCandidatesComponent,
        PageStatusForbiddenComponent,
        LayoutReviewComponent,
        PageReviewTasksComponent,
        PageStatusNot_foundComponent,
        LayoutAuthoringComponent,
        PageAccessComponent,
        PageAdminAccountsComponent,
        PortalSeasonLoadingSeasonComponent,
        PageStatusPendingComponent,
        PageAuthoringSourcesComponent,
        PageSignupComponent,
        PageAuthoringText_unitsComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }